// biome-ignore-all lint/performance/noImgElement: We are not using next/image here

import { useTranslations } from "@/hooks/use-translations";

export function CertificationBanner() {
  const { __ } = useTranslations();

  return (
    <div className="container pointer-events-none mx-auto mt-5 flex items-center justify-center gap-4 opacity-50">
      <div className="flex items-center justify-center gap-2">
        <img
          alt={__("auth.certifications.iso_27001_alt")}
          aria-labelledby="iso-27001"
          className="size-8"
          height={32}
          src="/img/certification/iso-27001.png"
          width={32}
        />
        <p className="flex flex-col" id="iso-27001">
          <span className="font-semibold text-xs">
            {__("auth.certifications.iso")}
          </span>
          <span className="font-semibold text-xs">
            {__("auth.certifications.iso_27001")}
          </span>
        </p>
      </div>
      <div className="flex items-center justify-center gap-2">
        <img
          alt={__("auth.certifications.gdpr_alt")}
          aria-labelledby="gdpr"
          className="size-8"
          height={32}
          src="/img/certification/gdpr.svg"
          width={32}
        />
        <p className="flex flex-col" id="gdpr">
          <span className="font-semibold text-xs">
            {__("auth.certifications.gdpr")}
          </span>
          <span className="font-semibold text-xs">
            {__("auth.certifications.gdpr_compliant")}
          </span>
        </p>
      </div>
      <div className="flex items-center justify-center gap-2">
        <img
          alt={__("auth.certifications.ce_alt")}
          aria-labelledby="ce"
          className="size-8"
          height={32}
          src="/img/certification/ce.svg"
          width={32}
        />
        <p className="flex flex-col" id="ce">
          <span className="font-semibold text-xs">
            {__("auth.certifications.ce_marking")}
          </span>
          <span className="font-semibold text-xs">
            {__("auth.certifications.eu_mdr")}
          </span>
        </p>
      </div>
    </div>
  );
}
